import { fetchFromRTM, subscribeToRTM } from './index';
import * as constants from './constants';
import './typedef';

const AI_SUMMARY_ACTIONS = {
  CREATE_TASK: 'createTask',
  SUMMARY: 'summary',
  HISTORY: 'history',
  CASE_STUDY: 'case-study',
  TRANSLATE: 'translate',
};

class AISummaryResolver {
  constructor(connection) {
    this.connection = connection;
  }

  generateContent = async ({ ambrosiaUrl, model, max_tokens, contents, taskId, correlationId, action, activityId, accountId, metadata }) => {
    const message = {
      type: constants.RTM_AUTHOR_SUMMARY_SNS,
      correlationId,
      action,
    };

    if (action === AI_SUMMARY_ACTIONS.CREATE_TASK) {
      message.ambrosiaUrl = ambrosiaUrl;
      message.model = model;
      message.max_tokens = max_tokens;
      message.contents = contents;
      message.elementId = activityId;
      message.accountId = accountId;

    } else if (action === AI_SUMMARY_ACTIONS.SUMMARY) {
      message.taskId = taskId;
      message.accountId = accountId;
    } else if (action === AI_SUMMARY_ACTIONS.HISTORY) {
      message.elementId = activityId;
      message.accountId = accountId;
    } else if (action === AI_SUMMARY_ACTIONS.CASE_STUDY) {
      message.ambrosiaUrl = ambrosiaUrl;
      message.metadata = metadata;
      message.contents = contents;
    } else if (action === AI_SUMMARY_ACTIONS.TRANSLATE) {
      message.contents = contents;
    }

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_SUMMARY_SNS_OK,
      constants.RTM_AUTHOR_SUMMARY_SNS_ERROR
    );

    return response;
  };

  summarySubscribe = async (correlationId, listener) => {
    const message = {
      type: constants.RTM_AUTHOR_SUMMARY_SNS_SUBSCRIBE,
      correlationId,
    };

    const subscription = await subscribeToRTM(
      this.connection,
      message,
      listener
    );

    // `await subscribeToRTM(..)` returns null if the subscription cannot be created.
    // In this case return an unsubscribe function that does nothing.
    if (!subscription) {
      const unsubscribeFn = () => { };
      return unsubscribeFn;
    }

    const unsubscribeMessage = {
      type: constants.RTM_AUTHOR_SUMMARY_SNS_UNSUBSCRIBE,
      correlationId,
    };
    const unsubscribeFn = () => subscription.unsubscribe(unsubscribeMessage);
    return unsubscribeFn;
  };
}

export default AISummaryResolver;
